module.exports = __webpack_public_path__ + "img/about_layout5.069ff6ed.png";